export enum AnalysisDataSourceType {
  FORECAST = 'FORECAST',
  ADDITIONAL_TIMESERIES = 'ADDITIONAL_TIMESERIES',
}
